import { useId } from "react";

/**
 * The Roomate symbol: the 2020 infinity of two diamond loops, drawn as one ribbon that
 * passes over itself at the crossing. Source of truth: marketing/brand/symbol.svg.
 * Uses currentColor, so it follows the text colour and theme.
 */
export function Symbol({ className, title = "Roomate" }: { className?: string; title?: string }) {
  const id = `rm-${useId().replace(/:/g, "")}`;
  const loops = "M0 0 L100 -100 L200 0 L100 100 Z M0 0 L-100 -100 L-200 0 L-100 100 Z";
  return (
    <svg viewBox="-250 -150 500 300" className={className} role="img" aria-label={title}>
      <mask id={id} maskUnits="userSpaceOnUse" x="-250" y="-150" width="500" height="300">
        <g fill="none" strokeLinejoin="round">
          <path d={loops} stroke="#fff" strokeWidth="72" />
          <path d={loops} stroke="#000" strokeWidth="38" />
          <path d="M-55 55 L55 -55" stroke="#fff" strokeWidth="72" />
          <path d="M-59 59 L59 -59" stroke="#000" strokeWidth="38" />
        </g>
      </mask>
      <rect x="-250" y="-150" width="500" height="300" fill="currentColor" mask={`url(#${id})`} />
    </svg>
  );
}

export function Logo({ className }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className ?? ""}`}>
      <Symbol className="h-[15px] w-auto" />
      <span className="text-[15px] font-medium tracking-[-0.02em]">roomate</span>
    </span>
  );
}
